import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Iframe from './Iframe.js';
import './style-inject.es-746bb8ed.js';
import './dataHooks.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const isSSR = typeof window === "undefined";
const HtmlSrcPath = "/html/2b2e4b_d767b483cae16e027c4ea8ac7906fbf4.html";
class IframeHtml extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { shouldRender: false });
    __publicField(this, "id", Math.random().toString(36).substr(2, 9));
    __publicField(this, "updateIframeContent", (content) => {
      var _a;
      this.shouldIgnoreLoad = true;
      (_a = this.iframe) == null ? void 0 : _a.contentWindow.postMessage(
        { type: "htmlPlugin:updateContent", id: this.id, content },
        "*"
      );
    });
    __publicField(this, "handleIframeMessage", ({ data }) => {
      const { type, id, height } = data;
      if (type === "htmlPlugin:heightResize" && id === this.id) {
        this.props.onHeightChange(height);
      }
    });
    __publicField(this, "handleIframeLoad", () => {
      !this.shouldIgnoreLoad && this.updateIframeContent(this.props.html);
    });
  }
  componentDidMount() {
    this.setState({ shouldRender: true });
    !isSSR && window.addEventListener("message", this.handleIframeMessage);
  }
  componentWillUnmount() {
    !isSSR && window.removeEventListener("message", this.handleIframeMessage);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.html !== nextProps.html) {
      this.updateIframeContent(nextProps.html);
    }
  }
  render() {
    const { iframeSandboxDomain, isViewer } = this.props;
    const strippedUrl = iframeSandboxDomain.replace(/\/$/, "");
    return this.state.shouldRender ? /* @__PURE__ */ React.createElement(
      Iframe,
      {
        style: { backgroundColor: "transparent" },
        onLoad: this.handleIframeLoad,
        iframeRef: (iframe) => this.iframe = iframe,
        isViewer,
        src: strippedUrl + HtmlSrcPath
      }
    ) : null;
  }
}
IframeHtml.propTypes = {
  html: PropTypes.string.isRequired,
  onHeightChange: PropTypes.any,
  iframeSandboxDomain: PropTypes.string,
  isViewer: PropTypes.bool
};

export { IframeHtml as default };
//# sourceMappingURL=IframeHtml.js.map
